export default {
  apiUrl: `${process.env.BACKEND_API_URL}/api`,
  locationApi: `${process.env.LOCATION_SERVICE_BACKEND_API_URL}`,
  // apiUrl: 'https://chitdev01.universalextras.co.uk/api',
  

  baseUrl: '/',
  adAppUrl: process.env.GV_CONFIG_AD_APP_URL
};
